<template>
    <div class="tab-account-setting">
        <div class="blockcont">
            <div class="smalltitle">Account Setting</div>
            <form>
                <div class="prolabel">Sign-in Email address</div>
                <div class="profield"><input type="text" v-model="userInfo.email" :disabled="disabledForm"><br>
                    <div class="explain"><em>Email address is your sign-in ID, change it will change your
                        sign-in info too.</em></div>
                </div>
                <div class="prolabel">Private Phone number</div>
                <div class="profield"><input type="text" v-model="userInfo.phoneRecovery" :disabled="disabledForm"
                                             name="phone">
                    <br>
                    <div class="explain"><em>Recovery phone number. In case lost of email, you can retrieve your
                        sign-in with this number.</em></div>
                </div>
              <div class="prolabel">Wikiallergies email</div>
              <div class="profield"><input type="text" v-model="userInfo.wikiEmail" :disabled="disabledForm"></div>
              <div class="prolabel">
                <button href="javascript:void(0)" @click.prevent="showConfirmCode()"
                        :disabled="(!staffClinic || (staffClinic.clinic_id && staffClinic.status != 1))">
                  Get confirm Code
                </button>
              </div>
              <div class="profield">
                <p v-if="staffClinic">Clinic: {{ staffClinic.fullName}}</p>
                <p v-if="staffClinic && staffClinic.join_day">Join day: {{ formatFullTime12Hour(staffClinic.join_day) }}</p>
                <p v-if="staffClinic">Email-phone-active: {{ staffClinic.email_phone_active}}</p>
                <p v-if="staffClinic">Permissions: {{ permissionClinic }}</p>
                <p v-if="activeCodeClinic">The last code is: {{ activeCodeClinic }}</p>
                <p v-if="failCodeClinic">Code not available</p>
              </div>
            </form>

        </div>
    </div>
</template>

<script>

import DetailRegularUserMixin from '../../../../mixins/user/UserStatusMixin.vue'
import httpClient from '@/client'

export default {
  name: 'TabAccountSetting',
  components: { },
  props: {
    userInfo: {},
    payments: {},
    addressBillings: {},
    checkingAccounts: {},
    disabledForm: {},
    staffClinic: {},
    user: {}
  },
  mixins: [DetailRegularUserMixin],
  data () {
    return {
      activeCodeClinic: '',
      failCodeClinic: false
    }
  },
  computed: {
    permissionClinic () {
      if (this.staffClinic) {
        return JSON.parse(this.staffClinic.permission)
      }
      return null
    }
  },
  watch: {

  },
  updated () {
  },
  mounted () {

  },
  beforeDestroy () {
  },
  methods: {
    async showConfirmCode () {
      if (!this.staffClinic || (this.staffClinic.clinic_id && this.staffClinic.status != 1)) {
        return
      }
      try {
        let response = await httpClient.get('/users/get-active-code-clinic?staff_id=' +
            this.user.id + '&clinic_id=' + this.staffClinic.clinic_id
        )
        if (response.data.s === 200) {
          this.activeCodeClinic = response.data.data
          this.failCodeClinic = !response.data.data
        } else {
          this.alertError(response.data.msg)
          this.modal = false
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
